import React from 'react'
import * as styles from './FeaturedCategories.module.css'

import { Link } from 'gatsby'

const featuredCategories = [
  {
    name: 'TypeScript',
    category: 'typescript',
    color: 'dodgerblue',
    textColor: 'white',
  },
  {
    name: 'JavaScript',
    category: 'javascript',
    color: 'gold',
    textColor: 'black',
  },
  { name: 'Vim', category: 'vim', color: 'forestgreen', textColor: 'white' },
  {
    name: 'VSCode',
    category: 'vscode',
    color: 'steelblue',
    textColor: 'white',
  },
  {
    name: 'Career',
    category: 'career',
    color: 'orangered',
    textColor: 'white',
  },
]

export const FeaturedCategories = () => {
  return (
    <aside className={styles.featuredCategories}>
      <header className={styles.header}>
        <h1>Featured Topics</h1>
      </header>
      <section className={styles.categories}>
        {featuredCategories.map((c) => (
          <Link
            key={c.name}
            style={{ backgroundColor: c.color, color: c.textColor }}
            to={`/blog/categories/${c.category}`}
            className={styles.category}
          >
            {c.name}
          </Link>
        ))}
      </section>
    </aside>
  )
}
